import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { arrayOf, shape } from 'prop-types'
import { useState } from 'react'
import styled from 'styled-components'
import { string } from 'yup/lib/locale'
import { Heading, HeadingSize } from '../../../../components/Ui-Kits/Text'
import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons'
import { useQuery } from '../../../../hooks/query/useQuery'
import { CategoryItem } from './CategoryItem'
import { useAppTranslation } from 'i18n/hooks'
import { theme } from 'globalStyles'
import { createPortal } from 'react-dom'

export const Categories = ({ options, title, name }) => {
  const [open, setOpen] = useState(() => {
    return window.innerWidth > 576
  })
  const toggleOpen = () => setOpen(open => !open)
  const { [name]: values } = useQuery()
  const { t } = useAppTranslation()

  return (
    <Wrap open={open}>
      <HeadingWrap onClick={toggleOpen}>
        <Heading color="primary" size={HeadingSize.SMALLEST} mt={0} mb={0}>
          {title}
        </Heading>
        <Icon icon={open ? faAngleUp : faAngleDown} />
      </HeadingWrap>
      <CategoriesWrap show={open}>
        <CategoryItem label={t('allCategories')} name={name} values={values} />
        {options.map(({ label, value, children = [] }) => (
          <CategoryItem
            label={label}
            value={value}
            key={value}
            name={name}
            childrenOptions={children}
            values={values}
          />
        ))}
      </CategoriesWrap>
      {open && createPortal(<TransparentWrap onClick={() => setOpen(false)} />, document.body)}
    </Wrap>
  )
}

Categories.propTypes = {
  options: arrayOf(
    shape({
      label: string.isRequired,
      value: string.isRequired,
    })
  ).isRequired,
  title: string.isRequired,
  name: string.isRequired,
}

const Wrap = styled.div`
  margin-bottom: 2rem;
  position: relative;
  ${({ open }) => open && `margin: 0 -1rem;`}
  z-index: ${({ open }) => (open ? 1000 : 'auto')};
  &:last-child {
    margin-bottom: 0;
  }

  ${theme.breakpoints.tablet} {
    margin: 0;
    margin-bottom: 2rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`
const HeadingWrap = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
  user-select: none;
  background-color: var(--color-white);
  height: 72px;
  padding: 1rem;

  ${theme.breakpoints.tablet} {
    padding: 0;
    background-color: var(--color-transparent);
    height: auto;
    justify-content: flex-start;
    z-index: auto;
  }
`
const Icon = styled(FontAwesomeIcon)`
  color: var(--color-primary);
  font-size: 1rem;
  ${theme.breakpoints.tablet} {
    font-size: 0.625rem;
  }
`

const CategoriesWrap = styled.div`
  padding-top: 0.5rem;
  overflow: auto;
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: absolute;
  z-index: ${({ open }) => (open ? 1000 : 'auto')};
  top: 100%;
  left: 0;
  width: 100%;
  background-color: var(--color-white);

  ${theme.breakpoints.tablet} {
    background-color: var(--color-transparent);
    z-index: auto;
    position: static;
    top: auto;
    left: auto;
  }
`
const TransparentWrap = styled.div`
  z-index: 99;
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  ${theme.breakpoints.tablet} {
    display: none;
    z-index: auto;
  }
`
